export default "__VITE_ASSET__DseeMI6L__"